import React from 'react';
import PortalService from '../../../services/portal/portal.service';
import { usePortalResource } from '../usePortalResource';
import PortalSection, { Card, EmptyState } from '../PortalSection';
import PortalAvatar from '../PortalAvatar';

/** Care team: staff first name, credential, discipline and photo only. */
const CareTeamScreen: React.FC<{ patientId: string }> = ({ patientId }) => {
  const { data, loading, error } = usePortalResource(PortalService.getCareTeam, patientId);
  return (
    <PortalSection title="Care team" loading={loading} error={error}>
      {data &&
        (data.members.length === 0 ? (
          <EmptyState>No care team members are assigned yet.</EmptyState>
        ) : (
          <ul className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
            {data.members.map((member, index) => (
              <li key={`${member.firstName}-${index}`}>
                <Card className="flex h-full items-center gap-4">
                  <PortalAvatar name={member.firstName} pictureUrl={member.pictureUrl} size="lg" />
                  <div className="min-w-0">
                    <p className="truncate font-semibold text-slate-900">{member.firstName}</p>
                    <div className="mt-1 flex flex-wrap items-center gap-2">
                      {member.credential && (
                        <span className="rounded-full bg-teal-50 px-2 py-0.5 text-xs font-semibold text-teal-800">
                          {member.credential}
                        </span>
                      )}
                      <span className="text-sm text-slate-700">
                        {[member.discipline, member.role].filter(Boolean).join(' · ')}
                      </span>
                    </div>
                  </div>
                </Card>
              </li>
            ))}
          </ul>
        ))}
    </PortalSection>
  );
};

export default CareTeamScreen;
